import React from 'react';
import PropTypes from "prop-types";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import { FIELD_TYPES } from '../../../../components/DynamicField/Tasks/utils/utils';
import FieldLookupOptions from './field-lookup-options';
import FieldTableOptions from './field-table-options';
import FieldUrlOptions from './field-url-options';
import {
    Field,
    Input,
    Textarea,
    MessageBar,
    MessageBarBody,
    makeStyles,
    FluentProvider,
    webLightTheme,
} from "@fluentui/react-components";

const useClasses = makeStyles({
    messageBarBody: {
      display: "flex",
      flexDirection: "row",
      gap: "10px",
    },
  });

const FieldInput = ({ disabled, fieldValues, setFieldValues, setFieldType }) => {

    const classes = useClasses();

    return (
        <FluentProvider theme={webLightTheme}>
            <div className='field-input'>
                {   fieldValues?.FieldType === "File" && (
                    <MessageBar intent="" shape="rounded" layout="multiline">
                        <MessageBarBody className={classes.messageBarBody}>
                            <div>
                                <FluentUiIcon
                                    name={"InfoRegular"}
                                    color={"#424242"}
                                    size={20}
                                />
                            </div>
                            <div>
                                Max file size is 5mb. Documents (DOC/X, XLS/X, CSV, PPT/X, PDF), Emails (EML and MSG) and images (PNG, JPG, GIF, SVG, TIFF) are supported.
                            </div>
                        </MessageBarBody>
                    </MessageBar>
                )}
                <div>
                    <Field label="API name" size="medium">
                        <Input
                            value={fieldValues.APIName}
                            onChange={(e) => setFieldValues({ ...fieldValues, ...{ APIName: e.target.value } })}
                            placeholder="Enter an API name"
                            disabled={disabled}
                        />
                    </Field>
                </div>
                <div>
                    <Field label="Field Description" size="medium">
                        <Textarea
                            value={fieldValues.Description}
                            onChange={(e) => setFieldValues({ ...fieldValues, ...{ Description: e.target.value } })}
                            placeholder="Enter Field Description"
                            disabled={disabled}
                            size='medium'
                        />
                    </Field>
                </div>
                <div>
                    <Field label="Default Field label" size="medium" required validationMessage={(fieldValues.Label.length < 1 && fieldValues.touched) && "Required value"}>
                        <Input
                            value={fieldValues.Label}
                            onChange={(e) => setFieldValues({ ...fieldValues, ...{ Label: e.target.value }, touched: true })}
                            placeholder="Enter default field label"
                            disabled={disabled}
                        />
                    </Field>
                </div>
                {
                    (fieldValues.FieldType === FIELD_TYPES.dropDown || fieldValues.FieldType === "Radio Buttons" || fieldValues.FieldType === FIELD_TYPES.checkbox)
                    && <FieldLookupOptions fieldValues={fieldValues} setFieldValues={setFieldValues} setFieldType={setFieldType} disabled={disabled} />
                }
                {
                    fieldValues.FieldType === FIELD_TYPES.table
                    && <FieldTableOptions fieldValues={fieldValues} setFieldValues={setFieldValues} disabled={disabled} />
                }
                {
                    fieldValues.FieldType === FIELD_TYPES.url && 
                    <FieldUrlOptions 
                        fieldValues={fieldValues} 
                        setFieldValues={setFieldValues} 
                        disabled={disabled}
                    />
                }
            </div>
        </FluentProvider>
    );
}

FieldInput.propTypes = {
    disabled: PropTypes.bool.isRequired,
    fieldValues: PropTypes.shape({
        APIName: PropTypes.string,
        Description: PropTypes.string,
        Label: PropTypes.string,
        touched: PropTypes.bool,
        FieldType: PropTypes.string,
    }).isRequired,
    setFieldValues: PropTypes.func.isRequired,
    setFieldType: PropTypes.func.isRequired,
};

export default FieldInput;
